import { CdvrRecording, RBAssetEntityType } from '../../types';

function isCdvrRecordingItem(item: any): item is CdvrRecording {
    return item.entityType === RBAssetEntityType.CdvrRecording;
}

export default isCdvrRecordingItem;
